import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

type SidebarcContainerProps = {
	collapsed?: boolean;
	className?: string;
	children?: React.ReactNode;
};

const SidebarContainer = ({ collapsed, className, children }: SidebarcContainerProps) => {
	return (
		<div
			className={twMerge(
				clsx(
					'fixed top-0 left-0 z-[45]',
					'bg-light flex flex-col gap-8 min-h-screen h-screen border border-tertiary px-4 py-5',
					'transition-[width] duration-300 ease-in-out',
					collapsed ? 'sidebar-collapsed-width' : 'sidebar-expanded-width',
					className,
				),
			)}
		>
			{children}
		</div>
	);
};

export default SidebarContainer;
